module.exports = __webpack_public_path__ + "public/be3dc6e206adf50f695cc2acd1408a63.ttf";